<svelte:head>
    <script  src="../dist/echarts.min.js" on:load={echartsLoaded} crossorigin="anonymous" defer></script>  

</svelte:head>

<script>

//
//  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
//     import defaultExport from "module-name";
//     import * as name from "module-name";
//     import { export1 } from "module-name";
//     import { export1 , export2 as alias2 , [...] } from "module-name";
//     import "module-name";
//     var promise = import("module-name");
//

import { onMount, onDestroy } from 'svelte';

import { loggedIn                                                   } from '../_services/accountsession.js';
import { cubejsclient_service  , cubejsclient_service_context_key   } from '../_services/cubejsClient.js';

//import MySvelteChart			from './Page_0001_Chart.svelte';   

// ----------------------------------------------------
// --   DECLARATIONS
// ----------------------------------------------------


var data = [];
let data_filters = [];

   var is_dataLoaded = false;
   onMount(async () => {
		if ($loggedIn) {
			// fetch data
		   fetchData();
			is_dataLoaded = true;
		}
	});

  var is_dependenciesLoaded = false;
  function dependenciesLoaded() {
  		if (   true 
  		       && is_echartsLoaded  
  		       && is_dataLoaded 
  		   )
  	  {
			is_dependenciesLoaded = true;
			buildApplet();
  		}
  }

  var is_echartsLoaded = false;
  function echartsLoaded() {
		is_echartsLoaded = true;
		dependenciesLoaded();
  }


  var is_dataLoaded = false;
  function fetchData() {
		is_dataLoaded = true;
		dependenciesLoaded();
  }

	onDestroy(() => { 
	});


  function buildApplet() {
  
        // based on prepared DOM, initialize echarts instance
        var myChart = echarts.init(document.getElementById('chart'));
console.log(myChart);
        
        // specify chart configuration item and data
        var option = {
            title: {
                text: 'ECharts entry example'
            },
            tooltip: {},
            legend: {
                data:['Sales']
            },
            xAxis: {
                data: ["shirt","cardigan","chiffon shirt","pants","heels","socks"]
            },
            yAxis: {},
            series: [{
                name: 'Sales',
                type: 'bar',
                data: [5, 20, 36, 10, 10, 20]
            }]
        };

        // use configuration item and data specified to show chart
        myChart.setOption(option);
        
        myChart.on('click', function(params) {
          console.log(params);
          if(! data_filters.find(function (elem) {
          					return elem.filter_key === params.seriesName && elem.filter_value === params.name
 				         }) 
          ) {
	          data_filters.push( { filter_key: params.seriesName, 
   	       							 filter_value: params.name,
      	   						 })
          }
//          console.log(data_filters);

        });
  
  }


// ----------------------------------------------------
// --   RUNTIME 
// ----------------------------------------------------

/*
				setTimeout(() => {
				    // do something nifty
  				}, 500 + Math.random() * 500);

*/

//$: run = is_dependenciesLoaded && fetchData() // <<-- should be hanlded in the onMount() ??

$: display_chart = is_dependenciesLoaded;


</script>


<style>

	.applet {
		width: inherit;
		height:550px;
	}
	
	.chart {
		width: 600px;
		height:400px;
	}
 
</style>


<div class="applet">

	<div>
		<div>My Finances :: Financial Statements</div>
		<div>App Chart_0001</div>
	</div>

	<div id="chartFilters">
		<button name="clearFilters">Clear Filters</button>
		{data_filters.length}
		<ul>	
		{#each data_filters as { filter_key, filter_value }, i}
		<li> {i + 1}: {filter_key} {filter_value} </li>
		{/each}
		</ul>
	</div>

	{#if $loggedIn}
	
		{#if is_dependenciesLoaded}
		<div id="chartWrapper">
			<div id="chart" class="chart"></div>
		</div>
		     
		{:else}
		<div>
				<p> Loading data and scripts and what not... </p>
		</div>
	
		{/if}


	{:else}
	<div>
		<p>Please log in...</p>
	</div>
	{/if}

</div>
